<script>
    import PageHeader from "./PageHeader.svelte";
    export let background = 'forest';
    export let pageTitle = '';
    export let description = '';
</script>


<div class="max-h-screen flex flex-col">
    <PageHeader {pageTitle} {description}/>

    <div class="h-screen overflow-auto text-secondary-text whitespace-pre-line {background}">
        <div class='mt-2 flex flex-col justify-center items-center w-full'>
            <slot />
        </div>
    </div>

    <slot name="questionnaire-navigation-bar" />
</div>

<style>
    .gray {
        background-color: white;
    }

    .forest {
        background-image: url('/assets/matt-howard-A4iL43vunlY-unsplash.jpg');
        background-size: cover;
        background-attachment: fixed;
        background-position: center;
    }
</style>